/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ProductSwiper_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SwiperItem_itemSearch">;
    readonly " $refType": "ProductSwiper_itemSearch";
};
export type ProductSwiper_itemSearch$data = ProductSwiper_itemSearch;
export type ProductSwiper_itemSearch$key = {
    readonly " $data"?: ProductSwiper_itemSearch$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSwiper_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwiperItem_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '772e44a0100df240ed63337274df5f8e';
export default node;
